export default [

    {
        'id': 0,
        'handle': 'starred',
        'title': 'Starred',
        'icon': 'star'
    },
    {
        'id': 1,
        'handle': 'important',
        'title': 'Priority',
        'icon': 'info'
    },
    {
        'id': 2,
        'handle': 'dueDate',
        'title': 'Sheduled',
        'icon': 'time'
    },
    {
        'id': 3,
        'handle': 'today',
        'title': 'Today',
        'icon': 'calendar'
    },
    {
        'id': 4,
        'handle': 'completed',
        'title': 'Done',
        'icon': 'check'
    },
    {
        'id': 5,
        'handle': 'deleted',
        'title': 'Deleted',
        'icon': 'delete'
    }
];



// WEBPACK FOOTER //
// ./app/routes/todo/data/filters.js